import React from 'react';

/**
 * Returns an object representing key-value entries from current query string.
 */
export const useParams = (): { [key: string]: string } => {
  return React.useMemo(() => Object.fromEntries(new URLSearchParams(window.location.search)), []);
};
